import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { LoaderService } from 'src/app/core/interceptors/loader/loader.service';
import { AzureBlobStorageService } from 'src/app/core/services/azure-blob-storage/azure-blob-storage.service';
import { PermissionsService } from 'src/app/core/services/common/permissions.service';
import { EnvService } from 'src/app/core/services/env.service';
import { MultiTenantPodService } from 'src/app/core/services/multiTenantPod-management/multi-tenant-pod.service';
import { DialogService } from 'src/app/shared/dialog/confirm-dialog/dialog.service';
import { InputPattern } from 'src/app/shared/enum/inputPattern';
import { MultiTenantPods } from 'src/app/shared/enum/multi-tenant-pods';
import { NotificationService } from 'src/app/shared/notification/notification.service';
import { CacheService } from 'src/app/core/services/cache/cache.service';

const document_img = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="74" height="74" viewBox="0 0 74 74">
<image id="sheets" width="74" height="74" xlink:href="data:image/png;base64,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"/>
</svg>`;

const status = {
  Planned: 1,
  InProgress: 2,
  Completed: 3,
};
@Component({
  selector: 'app-pod-upgrade-list',
  templateUrl: './pod-upgrade-list.component.html',
  styleUrls: ['./pod-upgrade-list.component.scss'],
})
export class PodUpgradeListComponent implements OnInit {
  breadCrumbItems: any;
  public podCalendarEnum = MultiTenantPods;
  selectedPOD: number = 0;
  selectedVersion: number = 0;
  selectedPODControl = new FormControl(this.selectedPOD);
  isCloudOpsuser: boolean = false;
  isRMuser: boolean = false;
  isStartUpgrade: boolean = true;
  isCompleteUpgrade: boolean = true;
  createdBy: any;
  podScheduledata: any;
  plannedDate:any;
  podName:any;
  columnFilterCtrlPodname =new FormControl('');
  selectPodName : any = [];
  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private dialogService: DialogService,
    public dialog: MatDialog,
    private notificationService: NotificationService,
    private permissionService: PermissionsService,
    private multitenantpodService: MultiTenantPodService,
    private blobService: AzureBlobStorageService,
    private loader: LoaderService,
    private cacheService : CacheService,
    private titleService: Title
  ) {
    iconRegistry.addSvgIconLiteral(
      'document_img',
      sanitizer.bypassSecurityTrustHtml(document_img)
    );
  }
  pods: any[] = [];

  versions: any[] = [];

  frmPodUpgrade: FormGroup = new FormGroup({
    selectPod: new FormControl('', Validators.required),
    selectVersion: new FormControl('', Validators.required),
  });
  ngOnInit(): void {
    this.titleService.setTitle('Calendar | ALM Studio');
    if (
      this.permissionService.getPermission('UpgradeMultiTenantPOD') &&
      this.permissionService.getPermission('PreviewMultiTenantPODUpgrade')
    ) {
      this.isCloudOpsuser = true;
      this.breadCrumbItems = [
        { label: 'Home', path: 'resources' },
        { label: 'Upgrade', path: 'upgrade/pod-upgrade' },
        { label: 'Calendar', path: 'upgrade/pod-upgrade' },
      ];
    } else if (
      this.permissionService.getPermission('UpgradeMultiTenantPOD') &&
      !this.permissionService.getPermission('PreviewMultiTenantPODUpgrade')
    ) {
      this.isRMuser = true;
      this.breadCrumbItems = [
        { label: 'Upgrade', path: 'upgrade/pod-upgrade' },
        { label: 'Calendar', path: 'upgrade/pod-upgrade' },
      ];
    }
    if (this.isCloudOpsuser) {
      this.getpodCalendarList();
      this.columnFilterCtrlPodname.valueChanges.subscribe((value:any) => {
      this.columnFilterPodname(value); 
    })
  }
    if (localStorage.getItem('email') != null) {
      this.createdBy = localStorage.getItem('email');
    }
  }
//Function to get list of POD's available to start and upgrade
  getpodCalendarList() {
    try {
      this.multitenantpodService.GetPodCalendarList().subscribe((resp: any) => {
        if (resp.length > 0) {
          this.pods = resp;
          this.selectPodName= resp;
        }
      });
    } catch (e) {
      console.log('Exception', e);
    }
  }

  //Function to download the template for RM User 
  downloadTemplate() {
    try {
      var FileSaver = require('file-saver');
      let fileName = 'MtPodUpgrade_Template.xlsx';
      this.multitenantpodService
        .downloadPodcalendarTemplate()
        .subscribe((resp: any) => {
          if (resp != undefined && resp != null) {
            this.blobService.downloadImageExt(
              resp.sasUrl,
              resp.container,
              resp.blob,
              (response: any) => {
                if (response._response.status == 200) {
                  response.blobBody.then((onres: any) => {
                    FileSaver.saveAs(onres, fileName);
                  });
                  this.notificationService.showNotification(
                    this.podCalendarEnum.pod_calendar_template_downlaod_body,
                    'success',
                    this.podCalendarEnum.pod_calendar_template_downlaod_heading
                  );
                } else {
                  this.notificationService.showNotification(
                    this.podCalendarEnum
                      .pod_calendar_template_downlaod_Error_body,
                    'error',
                    this.podCalendarEnum
                      .pod_calendar_template_downlaod_Error_header
                  );
                }
              }
            );
          }
        });
    } catch (err) {
      console.log(err);
    }
  }

  //Function to check which pod is selected
  PODSelectionChange(pod: any) {
    this.plannedDate = '';
    this.frmPodUpgrade.get('selectVersion')?.reset();
    let selectedpod = this.pods.filter((data) => data.podId === pod.value);
    this.versions = selectedpod[0]?.schedules;
    this.versions = this.versions?.sort((a:any, b:any) =>{ return b.targetVersion.localeCompare(a.targetVersion, undefined, { numeric: true, sensitivity: 'base' });});
    this.podName = selectedpod[0]?.podName;
  }

  columnFilterPodname(value: any) {
    const valueLowerCase = value.toLowerCase();
    this.selectPodName = this.pods.filter((x: any) =>
      x.podName.toLowerCase().includes(valueLowerCase),
    );
  }
  //Function to mark pod upgrade as started
  startUpgrade() {
    this.dialogService
      .confirmDialog({
        title: 'Confirm',
        module: 'Pod Calendar',
        message:
          this.podCalendarEnum.pod_calendar_start_upgrade_confirm_message + '<div class="confirm-text">POD Name: ' +this.podName+ '</div>' + '<div>Planned upgrade date: ' +this.plannedDate+ '</div>'+'<div class="confirm-text">Are you sure you want to continue?</div>',
        confirmText: 'Yes',
        cancelText: 'Cancel',
      })
      .subscribe((res: any) => {
        if (res) {
          //Start upgrade code
          this.loader.show();
          let data = {
            podId: this.selectedPOD,
            scheduleRequestId: this.selectedVersion,
            action: status.InProgress,
            comment: '',
            createdBy: this.createdBy,
          };
          this.multitenantpodService
            .startPodUpgrade(data)
            .subscribe((res: any) => {
              if (res != null || res != undefined || res != '') {
                if (res.body.isSuccessful == true) {
                  this.notificationService.showNotification(
                    this.podCalendarEnum.pod_calendar_start_pod_upgrade_body,
                    'success',
                    this.podCalendarEnum.pod_calendar_start_pod_upgrade_header
                  );
                }
              }
              this.cacheService.clearUrlData('api/MTPodUpgradeCalendar/MTPods');
              this.getpodCalendarList();
              this.loader.hide();
            });

          this.isStartUpgrade = false;
          this.isCompleteUpgrade = true;
        }
      });
  }

  //Function to check the version selected in select Version Drop down 
  versionSelectionChange(version: any) {
    if (this.selectedPOD != 0 && this.selectedVersion != 0) {
      let filteredPods = this.pods.filter(
        (data) => data.podId === this.selectedPOD
      );

      let filteredObjects = filteredPods[0]?.schedules.filter(
        (obj: { scheduleId: number }) => obj.scheduleId === this.selectedVersion
      );
      this.plannedDate = filteredObjects[0]?.plannedDate.slice(0,10);
      if (filteredObjects[0]?.status == status.Planned) {
        this.isStartUpgrade = true;
        this.isCompleteUpgrade = false;
      } else if (filteredObjects[0]?.status == status.InProgress) {
        this.isStartUpgrade = false;
        this.isCompleteUpgrade = true;
      } else {
        this.isStartUpgrade = true;
        this.isCompleteUpgrade = true;
      }
    }
  }

  //popup screen for uploading file for RM and Cloud Ops User
  uploadCalendar() {
    if (this.isCloudOpsuser) {
      this.podScheduledata = {
        podId: this.selectedPOD,
        scheduleRequestId: this.selectedVersion,
        createdBy: this.createdBy,
        podName: this.podName,
        plannedDate:this.plannedDate
      };
    } else if (this.isRMuser) {
      this.podScheduledata = {};
    }

    const dialogRef = this.dialog.open(uploadPodCalendar, {
      width: '500px',
      data: this.podScheduledata,
       disableClose: true 
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.isStartUpgrade = false;
      if (this.isCloudOpsuser && result == true) {
        this.frmPodUpgrade.reset();
        this.cacheService.clearUrlData('api/MTPodUpgradeCalendar/MTPods');
        this.versions = [];
        this.plannedDate = '';
        this.getpodCalendarList();
      }
    });
  }
}

@Component({
  selector: 'upload-pod-calendar-dialog',
  templateUrl: './upload-pod-calendar-dialog.html',
  styleUrls: ['./pod-upgrade-list.component.scss'],
})
export class uploadPodCalendar {
  public podCalendarEnum = MultiTenantPods;
  @ViewChild('fileInput')
  fileInput!: ElementRef;
  fileAttr = '';
  file: any;
  fileSizeLimit = this.env.fileSizeLimitExtension;
  listofUploadedFiles: any[] = [];
  extensionArray: any = ['xlsx', 'xls'];
  isCloudOpsuser: any;
  isRMuser: any;
  uniqueIdentifier: any;
  sas: any;
  azUrl: any;
  eventObject: any = {};
  fileArray: any[] = [];
  isFileExists: boolean = true;
  isUploadComplete = false;
  uploadInterval: any;
  uploadIntervalDuration: any;
  isFileExistInBlob: boolean = false;
  uploadStopIntervalDuration: any;
  loaderIntervalId:any;
  public regex = InputPattern;
  descRegex: any = new RegExp(this.regex.descriptionPattern);
  errorDescription: any = this.regex.errorMessage;
  loading$:any;
  constructor(
    public dialogRef: MatDialogRef<uploadPodCalendar>,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private permissionService: PermissionsService,
    private multitenantpodService: MultiTenantPodService,
    private loader: LoaderService,
    private blobService: AzureBlobStorageService,
    private env:EnvService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  frmPodUploadCalendar: FormGroup = new FormGroup({
    enterComments: new FormControl('', [Validators.required, Validators.pattern(this.descRegex)]),
  });

  ngOnInit(): void {
    this.uploadIntervalDuration = localStorage.getItem('uploadSetIntervalDuration');
    this.uploadStopIntervalDuration = localStorage.getItem('uploadStopIntervalDuration');
    if (
      this.permissionService.getPermission('AddInstance') &&
      this.permissionService.getPermission('UpgradeMultiTenantPOD')
    ) {
      this.isCloudOpsuser = true;
    } else if (
      !this.permissionService.getPermission('AddInstance') &&
      this.permissionService.getPermission('UpgradeMultiTenantPOD')
    ) {
      this.isRMuser = true;
    }
    this.loading$ = this.loader.loading$;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
  //validation message for the comments field by Cloud ops user
  valueChangeDescription(event: any) {
    if (event == undefined) {
      this.errorDescription = this.regex.errorMessage;
      return;
    }
    if (!this.descRegex.test(event[0])) {
      this.errorDescription = this.regex.firstCharacterErrorMessage;
      return;
    }
    else {
      this.errorDescription = this.regex.errorMessage;
    }
  }
  // For uploading file
  uploadFileEvt(File: any) {
    let fileExtension = File.target.files[0].name.split('.').pop();
    if (this.extensionArray.indexOf(fileExtension) <= -1) {
      this.notificationService.showNotification(
        this.podCalendarEnum
          .pod_calendar_template_incorrect_file_extension_body,
        'warning',
        this.podCalendarEnum
          .pod_calendar_template_incorrect_file_extension_header
      );
      this.listofUploadedFiles = [];
      this.fileArray = [];
      this.fileInput.nativeElement.value = '';
      this.file = '';
      return;
    }
    if (File.target.files && File.target.files[0]) {
      this.file = File.target.files[0];
      var filesize = Number((this.file.size / 1024 / 1024).toFixed(4));
      if (this.file.size == 0) {
        this.notificationService.showNotification(
          this.podCalendarEnum
            .pod_calendar_template_notify_emptyFile_body,
          'error',
          this.podCalendarEnum
            .pod_calendar_template_notify_emptyFile_header
        );
        this.file = null;
        this.fileInput.nativeElement.value = '';
        this.fileAttr = 'Choose File';
        return;
      }
      if (filesize > this.fileSizeLimit) {
        this.notificationService.showNotification(
          this.podCalendarEnum.pod_calendar_template_notify_fileSizeExceed_body,
          'error',
          this.podCalendarEnum.pod_calendar_template_notify_fileSieExceed_header
        );
        this.file = null;
        this.fileInput.nativeElement.value = '';
        this.fileAttr = 'Choose File';
        return;
      }
      this.fileAttr = '';
      this.fileAttr = File.target.files[0].name;
      this.listofUploadedFiles.push(this.fileAttr);

      if (this.isRMuser) {
        this.addFile();
      }
    } else {
      this.fileAttr = 'Choose File';
    }
  }
//For displaying which file is selected for Upload 
  addFile() {
    if (
      this.fileAttr != null &&
      this.fileAttr != '' &&
      this.fileAttr != undefined &&
      this.fileAttr != 'Choose File'
    ) {
      this.listofUploadedFiles = [];
      this.fileArray = [];
      this.listofUploadedFiles.push(this.fileAttr);
      this.fileArray.push({
        fileContent: this.file,
        fileName: this.file.name,
        isUploaded: false,
      });
      this.isFileExists = false;
    }
  }
  // To remove selected file
  removeFileTag(item: any) {
    const index = this.listofUploadedFiles.indexOf(item);
    if (index >= 0) {
      this.listofUploadedFiles = [];
      this.fileArray = [];
      this.fileInput.nativeElement.value = '';
      this.file = '';
      this.isFileExists = true;
    }
  }

  uploadAndSaveFile() {
    this.Submit();
  }
  //Confirmation pop up screen for sending email notification to users
  confirmUpload(params: any) {    
    this.dialogService
      .confirmDialog({
        title: 'Upload successful',
        module: 'Approve Upload',
        message: this.podCalendarEnum.pod_calendar_confirm_upload_message,
        confirmText: 'Notify CloudOps',
        cancelText: 'Cancel',
      })
      .subscribe((res: any) => {
        if (res) {
          this.multitenantpodService
            .sendEmailToCloudOps(params)
            .subscribe((res: any) => {
              if (res) {
                this.notificationService.showNotification(
                  this.podCalendarEnum.pod_calendar_confirm_upload_success_body,
                  'success',
                  this.podCalendarEnum.pod_calendar_confirm_upload_success_header
                );

              }
            });
        }
      });
  }

  //To get sas token and unique identifier for uplaoding the file
  async setTokenForIdentifier(): Promise<any> {
    try {
      return this.multitenantpodService
        .GetPodCalendarUploadConnection()
        .toPromise();
    } catch (execption) {
      console.log(execption);
    }
  }

  //Upload file function for Cloud Ops User
 async uploadFile(): Promise<any>{
  this.loader.show();
    let resToken = await this.setTokenForIdentifier();
          if (resToken != null && resToken != undefined) {
            this.sas = resToken.sasUrl;
            this.uniqueIdentifier = resToken.container;
          }
    return new Promise((resolve) => {
      try {
          this.blobService.uploadFiles(
            this.sas,
            this.uniqueIdentifier,
            this.file,
            this.file.name,
            (response: any) => {
              resolve('test');
              if (response._response != undefined) {
                this.azUrl = response._response.request.url;
              }
            }
          );
      } catch (exception) {
        this.loader.hide();
        console.log(exception);
      }
    });
}

//Upload and Save file function for RM User
  async uploadFileAsynchronously(): Promise<any> {
    this.loader.show();
    return new Promise((resolve) => {
      try {
        this.fileArray.forEach((x: any) => {
          this.blobService.uploadFiles(
            this.sas,
            this.uniqueIdentifier,
            x.fileContent,
            x.fileName,
            (response: any) => {
              this.notificationService.showNotification(
                this.podCalendarEnum.pod_calendar_file_save_progress_body,
                'success',
                this.podCalendarEnum.pod_calendar_file_save_progress_header
              );
              this.loader.show();
              if (
                response._response != undefined &&
                this.uploadIntervalDuration != null
              ) {
                this.onNoClick();
                this.loader.show();
                this.uploadInterval = setInterval(() => {
                  if (this.isFileExistInBlob == false){
                    this.loader.show();
                    this.multitenantpodService.checkBlobFileExist(this.uniqueIdentifier, this.file.name).subscribe((res: any) => {
                      if (res == true) {
                        this.isFileExistInBlob = true;
                          let params = {
                            blobName: this.uniqueIdentifier,
                            fileName: this.file.name,
                            createdBy: this.permissionService.getuserEmail(),
                          };
                          this.multitenantpodService
                            .saveUploadedFile(params)
                            .subscribe((res: any) => {
                              if (res) {
                                if(res.body.totalRecords>0){
                                  let emailData = {
                                    "ScheduleRecordIds": res.body.scheduleRecordIds,
                                    "IsCloudOpsEmail": true
                                  }
                                  this.notificationService.showNotification(
                                    this.podCalendarEnum
                                      .pod_calendar_file_save_completed_body,
                                    'success',
                                    this.podCalendarEnum
                                      .pod_calendar_file_save_completed_header
                                  );
                                  this.loader.hide();
                                  this.confirmUpload(emailData);
                                }
                              else if( res.body.totalRecords == 0 && res.body.statusCode == 200){                                
                                this.notificationService.showNotification(
                                  this.podCalendarEnum.pod_calendar_notification_duplicate_records_body,
                                   'warning',
                                   this.podCalendarEnum.pod_calendar_notification_duplicate_records_heading
                                 );
                                 this.loader.hide();
                              }
                              else{
                                this.notificationService.showNotification(
                                  this.podCalendarEnum.pod_calendar_error_file_upload_body,
                                   'error',
                                   this.podCalendarEnum.pod_calendar_error_file_upload_header
                                 );
                                 this.loader.hide();
                              }
                              this.isUploadComplete= true;
                              }
                            },(error)=>{
                              clearInterval(this.uploadStopIntervalDuration);
                              this.notificationService.showNotification(
                                this.podCalendarEnum.pod_calendar_error_file_upload_body,
                                 'error',
                                 this.podCalendarEnum.pod_calendar_error_file_upload_header
                               );
                              this.loader.hide();
                            });
                      }
                      else {
                        this.isFileExistInBlob = false;
                      }
                    })
                    this.loader.hide();
                  }
                }, this.uploadIntervalDuration);
                setTimeout(() => { clearInterval(this.uploadInterval); }, this.uploadStopIntervalDuration);

                this.loaderIntervalId= setInterval(() =>{ 
                  if(typeof this.uploadInterval=='undefined')
                       this.loader.hide();
                  else
                  if(!this.isUploadComplete){
                       this.loader.show();
                  }
                 }, 1000);
  
                let loaderClearInterVal:number=this.uploadStopIntervalDuration;
                
                //closing the spinner after loaderClearInterVal duration completed
                setTimeout(()=>{
                    clearInterval(this.loaderIntervalId);
                    if(this.isFileExistInBlob==false){
                      this.notificationService.showNotification(
                        this.podCalendarEnum.pod_calendar_error_file_upload_body,
                         'error',
                         this.podCalendarEnum.pod_calendar_error_file_upload_header
                       );
                       this.loader.hide();
                      }   
                 }, (loaderClearInterVal));

                this.azUrl = response._response.request.url;
                x.isUploaded = true;
              }
            }
          );
        });
      } catch (execption) {
        this.loader.hide();
        console.log(execption);
      }
    });
  }


//To get sas and Unique identifier for RM user uploaded file
  async Submit() {
    try {
      let resToken: any;
      this.loader.show();
      if (this.fileAttr.length > 0) {
        if (this.listofUploadedFiles.length > 0) {
          resToken = await this.setTokenForIdentifier();
          if (resToken != null && resToken != undefined) {
            this.sas = resToken.sasUrl;
            this.uniqueIdentifier = resToken.container;
          }
        }
        this.uploadFileAsynchronously();
      }
    } catch (error) {
      console.log('final', error);
      this.loader.hide();
    }
  }

  //Function to mark the pod upgrade as Completed 
   CompletePodUpgrade() {
    if(this.file){
      this.uploadFile().then((result)=>{
        this.notifyPodUpgrade();
       })
    }
    else{
     this.notifyPodUpgrade();
    }
   
  }

  //call to notify start pod upgrade and  notify Complete pod Upgrade 
  notifyPodUpgrade() {
    let completeData = {
      podId: this.data.podId,
      scheduleRequestId: this.data.scheduleRequestId,
      action: status.Completed,
      comment: this.frmPodUploadCalendar.controls['enterComments'].value,
      createdBy: this.data.createdBy,
    };
    this.multitenantpodService
      .startPodUpgrade(completeData)
      .subscribe((res: any) => {
        if (res != null || res != undefined || res != '') {
          if (res.body.isSuccessful == true) {
            this.notificationService.showNotification(
              this.podCalendarEnum.pod_calendar_complete_pod_upgrade_body,
              'success',
              this.podCalendarEnum.pod_calendar_complete_pod_upgrade_header
            );
            this.dialogRef.close(true);
          }
        }
        this.loader.hide();
      });
  }


}
